import { render, staticRenderFns } from "./PoiPictureSlider.vue?vue&type=template&id=0884db20"
import script from "./PoiPictureSlider.js?vue&type=script&lang=js&external"
export * from "./PoiPictureSlider.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports